<script>
    import { navigate }   from "svelte-routing"
    import _              from 'lodash'
    import * as api       from '../../shared/api.js'
    import * as pages     from '../../shared/pages.js'
    import { company, domains }    from '../../shared/stores.js'
    import DomainDropdown from '../../shared/DomainDropdown.svelte'
    import Dropdown       from '../../shared/Dropdown.svelte'
    import SectionTitle   from '../../shared/SectionTitle.svelte'
    import Loader         from '../../shared/Loader.svelte'
    import Item           from '../../shared/Item.svelte'
    import PolicyItem     from './PolicyItem.svelte'

    let active    = -1
    let items     = []
    let domain    = null
    let loading   = false
    let error     = false
    let history   = false
    let warn      = false
    let archetype = empty()

    const match = /empresa\/([0-9]+)\/politicas\/(.+)/.exec(window.location)
    if(match) {
        domain = $domains.find(it => it.domain === match[2])    
    }

    function assemble(company, it) {
        return { 
            id          : it.id            , 
            company     : company.id       ,
            domain      : domain.id        , 
            name        : it.name          , 
            description : it.description   ,
            url         : it.url           ,
            version     : it.version       ,
            notifyUsers : it.notifyUsers   ,
            kind        : 'privacy_policy' ,
        }
    }

    function empty() {
        return { id: 0, notifyUsers: false, name: '', description: '', version: '', url: ''}
    }

    function isDirty(item, copy) {
        return ! _.isEqual(item, copy)
    }

    function onDomainSelected(selected) {
        domain = selected ? selected.value : null
        if(domain) {
            navigate(`/empresa/${$company.id}/politicas/${domain.domain}`)
        } else {
            navigate(`/empresa/${$company.id}/politicas`)
        }
    }

    function warnMissingFeature() {
        warn = true
        setTimeout(() => {
            archetype.notifyUsers = false
            warn = false
        }, 5000)
    }

    function onUpdate(it) {
        const method = it.id === 0 ? 'POST' : 'PUT'
        const payload = assemble($company, it)
        return pages
            .onUpdate('/policy', method, payload)
            .then(json => {
                archetype = empty()
                items = [json, ...items]
                return true
            })
    }

    function onRemove() {}

    function loadBuffer(domain) {
        if(domain) {
            loading = true
            return pages
                .onMount(`/policies/domain/${domain.id}`)
                .then(json => {
                    loading = false
                    items = json
                })
                .catch(err => {
                    loading = false
                    error = err
                })
        } else {
            items = []
        }
    }

    function filter(items, history) {
        if(history) {
            return items
        } else {
            if(items.length > 0) {
                return [items[0]]
            } else {
                return []
            }
        }
    }

    $: loadBuffer(domain)
    $: buffer = filter(items, history)

</script>

<style>
    .item .ui.label {
        width: 110px;
    }

    .item {
        margin: 1em 0;
    }

    .item:last-child {
        margin: 2em 0;
    }

    .input.larger, .input.larger input {
        width: 500px;
    }

    .ui.checkbox {
        margin-left: 57px;
    }

    .head label, .ui.checkbox label {
        font-size: 13pt;
    }
</style>

<svelte:head>
	<title>Dogma / {$company.name} / Políticas</title>
</svelte:head>

{#if loading || error}
    <Loader {error} what="Carregando" inverted={true}/>
{:else}
    <SectionTitle>
        Políticas {#if domain} para {domain.domain} {/if}
    </SectionTitle>

    <DomainDropdown {domain} {onDomainSelected} />

    <div class="ui raised segments">
        {#if items && items.length > 1}
            <div class="ui head right aligned segment">
                <div class="ui toggle big checkbox">
                    <input type="checkbox" bind:checked={history}>
                    <label>mostrar versões anteriores</label>
                </div>
            </div>
        {/if}
        <Item item={archetype} bind:active={active} {isDirty} {onUpdate} disabled={!domain}>
            <div slot="primary">
                <div class="item">
                    <div class="ui labeled big input" >
                    <div class="ui label">Nome</div>
                        <input  bind:value={archetype.name}
                                type="text"
                                autocomplete="false">
                    </div>
                </div>
                <div class="item">
                    <div class="ui labeled big input" >
                    <div class="ui label">Versão</div>
                        <input  bind:value={archetype.version}
                                type="text"
                                autocomplete="false">
                    </div>
                </div>
                <div class="item">
                    <div class="ui labeled big larger input" >
                    <div class="ui label">Link</div>
                        <input  bind:value={archetype.url}
                                type="text" 
                                autocomplete="false">
                    </div>
                </div>
                <div class="item">
                    <div class="ui labeled big larger input" >
                    <div class="ui label">Descrição</div>
                        <input  bind:value={archetype.description}
                                type="text" 
                                autocomplete="false">
                    </div>
                </div>
                <div class="item">
                    <div class="ui toggle big checkbox">
                        <input type="checkbox" on:change={warnMissingFeature} bind:checked={archetype.notifyUsers}>
                        <label>
                            {#if warn}
                                <span class="ui message">
                                    <i class="ban icon"></i>Esta funcionalidade estará disponível apenas no plano premium
                                </span>
                            {:else}
                                notificar usuários sobre a atualização da política de privacidade
                            {/if}
                        </label>
                    </div>
                </div>
            </div>        
        </Item>
        {#if !domain}
            <div class="ui segment">
                <div class="ui big message">
                    Selecione um domínio
                </div>
            </div>
        {:else if !items || items.length === 0}
            <div class="ui segment">
                <div class="ui big message">
                    Crie uma política de privacidade para o seu domínio
                </div>
            </div>
        {/if}
        {#each buffer as item (item.id)}
            <PolicyItem bind:item={item} 
                        bind:active={active} 
                        {onUpdate} 
                        {onRemove} />
        {/each}
    </div>
{/if}